import { jsx as e, jsxs as r } from "react/jsx-runtime";
import { ChevronRight as g } from "lucide-react";
import { forwardRef as L, useId as S } from "react";
import { C as f } from "./Card-BpiP0p3P.js";
import { P as p } from "./Pill-uAcQLotY.js";
import { S as l } from "./Skeleton-BOboktJd.js";
import { c as h } from "./cn-DlLpp5ix.js";
function E(t) {
  const a = [{ kind: "invit", days: 0 }];
  return t.fu1Days > 0 && a.push({ kind: "fu1", days: t.fu1Days }), t.fu2Days > 0 && a.push({ kind: "fu2", days: t.fu2Days }), t.fu3Days > 0 && a.push({ kind: "fu3", days: t.fu3Days }), a;
}
const b = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--space-3)",
  width: "100%"
}, w = {
  display: "flex",
  alignItems: "stretch",
  gap: "var(--space-2)",
  width: "100%",
  flexWrap: "wrap"
}, T = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "var(--space-1_5)",
  flex: "1 1 0",
  minWidth: 120
}, C = {
  width: "var(--space-8)",
  height: "var(--space-8)",
  borderRadius: "var(--radius-full)",
  background: "var(--accent-dim)",
  border: "1px solid var(--accent-border)",
  color: "var(--accent-default)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "var(--text-md)",
  fontFamily: "var(--font-sans)"
}, k = {
  fontSize: "var(--text-sm)",
  fontWeight: 700,
  color: "var(--text-primary)",
  textAlign: "center",
  margin: 0
}, _ = {
  fontSize: "var(--text-xs)",
  color: "var(--text-tertiary)",
  textAlign: "center",
  margin: 0,
  lineHeight: "var(--line-xs)"
}, D = {
  display: "inline-flex",
  alignItems: "center",
  alignSelf: "center",
  color: "var(--text-tertiary)",
  flex: "0 0 auto"
}, P = {
  display: "flex",
  justifyContent: "flex-end"
}, I = L(function({ cadence: a, dailyLimit: s, copy: i, className: u }, v) {
  const o = S(), c = E(a);
  return /* @__PURE__ */ e(
    f,
    {
      ref: v,
      asChild: !0,
      padding: "lg",
      radius: "2xl",
      className: h("ls-cadence-preview", u),
      children: /* @__PURE__ */ e(
        "section",
        {
          "aria-labelledby": o,
          "aria-label": i.ariaLabel,
          "data-ls-composite": "cadence-preview",
          "data-step-count": c.length,
          children: /* @__PURE__ */ r("div", { style: b, children: [
            /* @__PURE__ */ e(
              "span",
              {
                id: o,
                style: {
                  position: "absolute",
                  width: 1,
                  height: 1,
                  overflow: "hidden",
                  clip: "rect(0 0 0 0)"
                },
                children: i.ariaLabel
              }
            ),
            /* @__PURE__ */ e(
              "ol",
              {
                style: { ...w, listStyle: "none", padding: 0, margin: 0 },
                "data-ls-cadence-timeline": !0,
                children: c.map((n, y) => {
                  const m = y === c.length - 1, d = i.steps[n.kind], x = n.kind === "invit" ? i.invitDayLabel : i.fuDayLabel(n.days);
                  return /* @__PURE__ */ r("li", { style: { display: "contents" }, children: [
                    /* @__PURE__ */ r("div", { style: T, "data-ls-cadence-step": !0, "data-step-kind": n.kind, children: [
                      /* @__PURE__ */ e("span", { "aria-hidden": "true", style: C, children: d.icon ?? null }),
                      /* @__PURE__ */ e(
                        p,
                        {
                          tone: "accent",
                          variant: "soft",
                          size: "sm",
                          "data-ls-cadence-day": !0,
                          "data-step-kind": n.kind,
                          children: x
                        }
                      ),
                      /* @__PURE__ */ e("p", { style: k, "data-ls-cadence-step-label": !0, children: d.label }),
                      d.description ? /* @__PURE__ */ e("p", { style: _, "data-ls-cadence-step-desc": !0, children: d.description }) : null
                    ] }),
                    m ? null : /* @__PURE__ */ e("span", { style: D, "aria-hidden": "true", children: /* @__PURE__ */ e(g, { size: 16 }) })
                  ] }, n.kind);
                })
              }
            ),
            /* @__PURE__ */ e("div", { style: P, children: /* @__PURE__ */ e(
              p,
              {
                tone: "purple",
                variant: "soft",
                size: "sm",
                "data-ls-cadence-smart-limit": !0,
                "data-daily-limit": s,
                children: i.smartLimitLabel(s)
              }
            ) })
          ] })
        }
      )
    }
  );
});
I.displayName = "CadencePreview";
const O = "Loading cadence";
function W({
  className: t,
  "aria-label": a = O
}) {
  return /* @__PURE__ */ e(f, { padding: "lg", radius: "2xl", className: h("ls-cadence-preview-skeleton", t), children: /* @__PURE__ */ r(
    "div",
    {
      role: "status",
      "aria-label": a,
      "aria-busy": "true",
      style: { display: "flex", flexDirection: "column", gap: "var(--space-3)" },
      children: [
        /* @__PURE__ */ e("div", { style: { display: "flex", gap: "var(--space-3)" }, children: [0, 1, 2, 3].map((s) => /* @__PURE__ */ r(
          "div",
          {
            style: {
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "var(--space-1_5)"
            },
            children: [
              /* @__PURE__ */ e(l, { variant: "circle", width: 32, height: 32 }),
              /* @__PURE__ */ e(l, { variant: "rect", width: 56, height: 20 }),
              /* @__PURE__ */ e(l, { variant: "text", width: "80%", height: 12 }),
              /* @__PURE__ */ e(l, { variant: "text", width: "60%", height: 10 })
            ]
          },
          s
        )) }),
        /* @__PURE__ */ e("div", { style: { display: "flex", justifyContent: "flex-end" }, children: /* @__PURE__ */ e(l, { variant: "rect", width: 140, height: 20 }) })
      ]
    }
  ) });
}
export {
  I as C,
  W as a
};
//# sourceMappingURL=CadencePreview-Bwz4-CuJ.js.map
